module.exports = __webpack_public_path__ + "static/media/filosofia_D.aeec59a7.jpg";